import { Component } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api'

import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Meta } from '@angular/platform-browser';
import { MonitoringService } from "./services/monitoring.service";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  Interval
  constructor(public data :PHBHPLayoutPackageService,public translate: TranslateService, private router: Router, private monitoring: MonitoringService, private meta: Meta){
    this.data.serverUrl = environment.imageUrl;
    this.data.apiUrl = environment.apiUrl+"/api/";
    this.translate.setDefaultLang('en');
    //CONFLICT: metaTag was only present on phase2.
    this.meta.addTag({ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0' });
  }

  ngOnInit() {
    // setup application insights telemetry
    this.monitoring.initialise();

    this.data.init();

    this.data.setActionDate = () =>{
      clearTimeout(this.Interval);
      this.Interval = setTimeout(()=>{
        window.localStorage.removeItem('access_token');
        window.localStorage.removeItem('refresh_token');
        this.router.navigateByUrl('/login');

      }, 1 * 60 * 60 * 1000);
    }

    const selectedLanguage = () => {
      let lang = localStorage.getItem('selectedlanguage');
      lang = lang ? (lang == 'null' ? 'en': lang) : 'en';
      if (lang) {
        localStorage.setItem('selectedlanguage', lang);
      }

      const defaultLanguage = 'en'
      const selectedlanguageKey = 'selectedlanguage'

      const selectedLanguage = localStorage.getItem(selectedlanguageKey);
      if (!selectedLanguage) {
        localStorage.setItem(selectedlanguageKey, defaultLanguage);
        return defaultLanguage
      }

      return selectedLanguage
    }

    this.translate.use(selectedLanguage());

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  title = 'angular7-test';
}
